import React from 'react';
import Form from 'react-bootstrap/Form';

export function StaticTriggerDisplay(props: { triggerValue: string }) {
  const { triggerValue } = props;
  return (
    <Form.Group>
      <Form.Label>Trigger</Form.Label>
      <div className="font-monospace small">{triggerValue || '—'}</div>
      <Form.Text className="text-muted">
        Uses the promotion identifier as the contest trigger value.
      </Form.Text>
    </Form.Group>
  );
}
